"use client";

import React from "react";

//Styled
import * as S from "./styles";

//Types
import { CardStatisticsProps } from "@/types";

const LargeCardDash: React.FC<CardStatisticsProps> = ({
  className,
  title,
  value,
  descriptionValue,
  color = "green",
  children,
  itemList,
  colorValue = "colorTitle",
}) => {
  return (
    <S.BoxCard className={className}>
      <S.HeaderCard>
        <S.Title> {title} </S.Title>
        <S.Value $colorValue={colorValue}>
          {" "}
          {value}{" "}
          {descriptionValue && (
            <S.TextColor $color={color}>{descriptionValue}</S.TextColor>
          )}
        </S.Value>
      </S.HeaderCard>
      <S.ListSmall>
        {itemList &&
          itemList.map((item, index) => (
            <S.ItemList key={index}>
              <S.Title> {item.titleItem} </S.Title>
              <S.Value $colorValue={item.colorItem}>
                {" "}
                {item.valueItem}{" "}
                {item.descriptionItem && (
                  <S.TextColor
                    $color={
                      item.colorItem === "red" ||
                      item.colorItem === "green" ||
                      item.colorItem === "blue"
                        ? item.colorItem
                        : "green"
                    }
                  >
                    {item.descriptionItem}
                  </S.TextColor>
                )}
              </S.Value>
            </S.ItemList>
          ))}
      </S.ListSmall>
    </S.BoxCard>
  );
};

export default LargeCardDash;
